import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import './slick.min.js';


jQuery(document).foundation();

jQuery(window).scroll(function() {
    if (jQuery(document).scrollTop() > 0) {
        jQuery('body').addClass("fixed");
    } else {
        jQuery("body").removeClass("fixed");
    }
});

/**
 * Manage Slider
 */

jQuery('.js-home-slideshow').slick({
    autoplay: true,
    prevArrow: jQuery('#home-slideshow-prev'),
    nextArrow: jQuery('#home-slideshow-next'),
    dots: true,
    speed: 300,
    autoplaySpeed: 3000,
    useCSS: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    appendDots: jQuery('.s-home-slideshow-controller'),
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    touchMove: true,
    cssEase: 'linear'
});

jQuery('.js-trending-slider').slick({
    autoplay: true,
    prevArrow: jQuery('#trending-slider-prev'),
    nextArrow: jQuery('#trending-slider-next'),
    dots: true,
    speed: 400,
    autoplaySpeed: 3000,
    useCSS: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    appendDots: jQuery('.s-trending-slider-controller'),
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    touchMove: true,
    cssEase: 'linear'
});


/**
 * Manage hamburger menu
 */

// if (!this.isMobileBreakpoint()) return;

let self = this,
    $navListItem = $('.s-sidebar-nav li.menu-item-has-children > a'),
    $navListItemParentAll = $('.s-sidebar-nav li.menu-item-has-children'),
    $navListItemAll = $('.s-sidebar-nav > li'),
    $sidebarNavOpener = $('.js-sidebar-nav-open'),
    $sidebarNavCloser = $('.js-sidebar-nav-close'),
    $sidebarNav = $('#sidebar-nav'),
    $currentMenuItem = $sidebarNav.find('current-menu-item');

	$navListItem.click(function(e){
	   e.preventDefault();

        //console.log('cool2');

        let $handler = $(this),
            $parentItem = $handler.parent('li');

        $navListItemAll.removeClass('current-menu-item');
        $navListItemParentAll.removeClass('current-menu-parent');
        $parentItem.toggleClass('current-menu-parent');

        if($parentItem.find('ul').hasClass('sub-menu-open')){
            $parentItem.find('.sub-menu-open').removeClass('sub-menu-open').slideUp();
        }else{
            $sidebarNav.find('.sub-menu-open').removeClass('sub-menu-open').slideUp();
            $parentItem.find('ul').addClass('sub-menu-open').slideDown();
        }
	});

	$sidebarNavOpener.on('click', function(){
	    $sidebarNav.toggleClass('open');
	});

	$sidebarNavCloser.on('click', function(){
	    $sidebarNav.toggleClass('open');
	});
    

/**
 * Manage Add or Remove Class
 */
jQuery(document).ready(function ($) {
    jQuery('.tabs a').click(function(){
        jQuery('.panel').slideUp();
        jQuery('.tabs a.active').removeClass('active');
        jQuery('.panel').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.panel').addClass('active');
         
        var panel = jQuery(this).attr('href');
        jQuery(panel).slideDown('fast');
         
        return false; 
    });

    jQuery('.tabs li:first a').click();
});

 /**
 * Manage Add or Remove Class
 */

jQuery('.c-secondary-nav__dot').click(function(){
	 if (jQuery('.c-secondary-nav__items').hasClass("active") ){
	    jQuery('.c-secondary-nav__items').removeClass("active");
	}
	else {
	    jQuery('.c-secondary-nav__items').addClass("active");
	}
});

jQuery(window).scroll(function(){
	if (jQuery(window).scrollTop() > 0){
	    jQuery('#top-bar').addClass("fixed");
	}
	else {
	    jQuery('#top-bar').removeClass("fixed");
	}
});

